import { useState } from 'react';
import { SCREEN_TYPES } from 'utils/constants';
import { useAppStore, useReceiptStore } from 'store';
import { Button } from 'components/ui/Button';
import { CardTitle } from 'components/ui/card';
import { Label } from 'components/ui/label';
import { handleProblemResolve } from 'utils/handleProblem';
import { UpcInputField } from './UpcInputField';
import { toast } from 'sonner';

export default function ScanItem() {
  const [loadingProblemClicked, setLoadingProblemClicked] = useState(false);
  const { setCurrentScreen } = useAppStore();
  const { receiptData } = useReceiptStore();

  const onCancel = () => setCurrentScreen(SCREEN_TYPES.SCAN_BOX);

  const onProblemClick = async () => {
    setLoadingProblemClicked(true);
    const result = await handleProblemResolve(SCREEN_TYPES.SCAN_ITEM);
    setLoadingProblemClicked(false);
    if (!result.success) {
      toast.error('Problem resolution failed. Please try again.');
    } else {
      toast.success('Problem resolved successfully.');
    }
  };

  return (
    <div className="space-y-4">
      <CardTitle className="mb-1 flex items-center justify-center gap-3 text-center text-xl font-extrabold tracking-tight text-slate-900">
        Scan Item
      </CardTitle>

      <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3">
        <span className="mr-2 text-sm font-semibold text-slate-600">Tracking #</span>
        <span className="break-all text-sm font-semibold text-slate-900">
          {receiptData?.tracking_id || receiptData?.receipt?.tracking_id || ''}
        </span>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
        <Label htmlFor="upc-input" className="mb-2 block text-sm font-semibold text-slate-700">
          UPC
        </Label>
        <UpcInputField />
      </div>

      <div className="buttons-container">
        <Button
          type="button"
          variant="secondary"
          className="h-12 flex-1 rounded-xl text-base font-semibold"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="destructive"
          className="h-12 flex-1 rounded-xl text-base font-semibold shadow-sm"
          disabled={loadingProblemClicked}
          onClick={onProblemClick}
        >
          Problem
        </Button>
      </div>
    </div>
  );
}
